import React, { forwardRef, useRef } from 'react';
import cn from 'classnames';
import { useFocus } from '@alfalab/hooks';
import { ChevronDownCompactSIcon } from '@alfalab/icons-glyph/ChevronDownCompactSIcon';
import { ChevronDownMIcon } from '@alfalab/icons-glyph/ChevronDownMIcon';
import { CrossCircleMIcon } from '@alfalab/icons-glyph/CrossCircleMIcon';
import { CrossCircleSIcon } from '@alfalab/icons-glyph/CrossCircleSIcon';

var commonStyles = {"component":"filter-tag__component_tkipl","disabled":"filter-tag__disabled_tkipl","rounded":"filter-tag__rounded_tkipl","xxs":"filter-tag__xxs_tkipl","xs":"filter-tag__xs_tkipl","s":"filter-tag__s_tkipl","checked":"filter-tag__checked_tkipl","content":"filter-tag__content_tkipl","focused":"filter-tag__focused_tkipl","chevron":"filter-tag__chevron_tkipl","valueButton":"filter-tag__valueButton_tkipl","outlined":"filter-tag__outlined_tkipl","filled":"filter-tag__filled_tkipl","open":"filter-tag__open_tkipl","close":"filter-tag__close_tkipl","clear":"filter-tag__clear_tkipl","iconWrapper":"filter-tag__iconWrapper_tkipl"};
require('./index.css');

var isKeyBoardEvent = function (event) {
    return event.key !== undefined;
};
var BaseFilterTag = forwardRef(function (_a, ref) {
    var _b, _c;
    var children = _a.children, checked = _a.checked, disabled = _a.disabled, open = _a.open, onClick = _a.onClick, _d = _a.size, size = _d === void 0 ? 's' : _d, _e = _a.variant, variant = _e === void 0 ? 'default' : _e, shape = _a.shape, _f = _a.view, view = _f === void 0 ? 'outlined' : _f, _g = _a.onClear, onClear = _g === void 0 ? function () { return null; } : _g, _h = _a.showClear, showClear = _h === void 0 ? true : _h, className = _a.className, dataTestId = _a.dataTestId, _j = _a.styles, styles = _j === void 0 ? {} : _j;
    var valueRef = useRef(null);
    var focused = useFocus(valueRef, 'keyboard')[0];
    var handleClear = function (event) {
        event.stopPropagation();
        if (isKeyBoardEvent(event)) {
            var clickSimilarKeys = ['Enter'].includes(event.key);
            if (clickSimilarKeys)
                onClear();
            return;
        }
        onClear();
    };
    var variantClassName = variant === 'default' ? 'rounded' : 'rectangular';
    var shapeClassName = shape || variantClassName;
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", { className: cn(className, commonStyles.component, commonStyles[shapeClassName], commonStyles[size], styles.component, styles[shapeClassName], styles[size], (_b = {},
            _b[commonStyles.checked] = checked,
            _b[styles.checked] = checked,
            _b[commonStyles.disabled] = disabled,
            _b[styles.disabled] = disabled,
            _b[commonStyles.focused] = focused,
            _b[commonStyles.open] = open,
            _b)), ref: ref, "data-test-id": dataTestId, onClick: disabled ? undefined : onClick },
        React.createElement("button", { type: 'button', ref: valueRef, disabled: disabled, className: cn(commonStyles.valueButton, styles.valueButton, commonStyles[size], styles[size], commonStyles[shapeClassName], styles[shapeClassName], commonStyles[view], (_c = {},
                _c[styles[view]] = Boolean(styles[view]),
                _c[commonStyles.checked] = checked,
                _c[styles.checked] = checked,
                _c[commonStyles.open] = open,
                _c[commonStyles.close] = !showClear,
                _c[styles.close] = !showClear,
                _c)) },
            React.createElement("span", { className: commonStyles.content }, children),
            React.createElement("span", { className: commonStyles.chevron }, size === 'xxs' || size === 'xs' ? (React.createElement(ChevronDownCompactSIcon, null)) : (React.createElement(ChevronDownMIcon, null)))),
        checked && !disabled && showClear && (React.createElement("div", { role: 'button', className: cn(commonStyles.clear, styles.clear, commonStyles[size], styles[size], styles[shapeClassName], commonStyles[shapeClassName]), onClick: handleClear, onKeyDown: handleClear, tabIndex: 0 },
            React.createElement("span", { className: commonStyles.iconWrapper }, size === 'xxs' ? React.createElement(CrossCircleSIcon, null) : React.createElement(CrossCircleMIcon, null))))));
});

export { BaseFilterTag };
